export const CONTENT_TYPE = {
  TV: 'TV',
  VOD: 'VOD',
  SHOW: 'TVSHOW',
  CATCHUP: 'CATCHUP',
  EVENT: 'EVENT',
} as const
export type CONTENT_TYPE = (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE]
